

import { Gallery, Item } from "react-photoswipe-gallery";
import { pdpData } from '@/redux/PDP/pdpSlice'
import { useSelector, useDispatch } from 'react-redux';
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  PinterestShareButton,
  TwitterShareButton,
  TwitterIcon,
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  PinterestIcon,

} from "react-share";
import Dropdown from 'react-bootstrap/Dropdown';
import { ShareSocial } from 'react-share-social'
import './style/pdp.css'
import { FaCircle } from "react-icons/fa6";
import { VscCopy } from "react-icons/vsc";
import { TbLocation } from "react-icons/tb";
import { trackButtonClick } from "@/utils/analytics";


export default function ListingOne({ property }) {

  const pdpInitData = useSelector((state) => state.pdp.pdpInitData);
  const isCWCOTFirstLook =
    pdpInitData?.propertyDetails?.commonAttributes?.propCategory ===
    'SC' &&
    pdpInitData?.propertyDetails?.cwcotUpdatesEnabled &&
    pdpInitData?.propertyDetails?.cwcotUpdatesValid;


  const streetNumber = property?.address?.streetNumber;
  const streetName = property?.address?.streetName;
  const city = property.address?.city;
  const stateName = property.address?.state;
  const zip = property.address?.zip;
  const state = property.address?.state;
  const beds = pdpInitData?.propertyDetails?.commonAttributes?.bedroomsNum;
  const isNewToHubzu = pdpInitData?.propertySpecialDetails?.isNewToHubzu || 'N';


  const label = {
    REO: 'BANK-OWNED',
    NPL: 'NON-PERFORMING LOAN',
    SC: pdpInitData?.propertyDetails?.sellerId !== '501' ? 'CWCOT-SECOND CHANCE' : 'BANK-OWNED',
    NON_REO: 'NON BANK-OWNED',
    FORECLOSURE: pdpInitData?.fcOnlineFlag === 'Y' ? 'ONLINE FORECLOSURE' : 'FORECLOSURE',
    SHRT_SALE: 'SHORT SALE',
    ABS: 'BANK-OWNED',
    COMMERCIAL: 'COMMERCIAL',
    CWCOT: 'CWCOT FIRST LOOK PROGRAM',
  };

  const color = {
    REO: 'rgb(255, 121, 0)',
    NPL: 'rgb(255, 121, 0)',
    SC: 'rgb(255, 121, 0)',
    NON_REO: '#cb5615',
    FORECLOSURE: 'rgb(143, 176, 53)',
    SHRT_SALE: '#2983bb',
    COMMERCIAL: 'rgb(255, 255, 255)',
    CWCOT: 'rgb(255, 121, 0)',
  };
  const bgColor = {
    REO: 'rgba(0, 0, 0, 0.6)',
    NPL: 'rgba(0, 0, 0, 0.6)',
    SC: 'rgba(0, 0, 0, 0.6)',
    NON_REO: 'rgba(0, 0, 0, 0.6)',
    FORECLOSURE: 'rgba(0, 0, 0, 0.6)',
    SHRT_SALE: 'rgba(0, 0, 0, 0.6)',
    COMMERCIAL: 'rgb(42, 105, 163)',
    CWCOT: 'rgba(255, 255, 255, 1)',
  };

  const renderNewTag = () => {
    if (isNewToHubzu === 'Y') {
      return (

        <div className="tags" style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', height: 18, textAlign: "center", borderRadius: 5, width: 60 }}>

          <p style={{ color: "white", fontSize: 12, paddingTop: 2 }} tabIndex="0">
            NEW
          </p>
        </div>
      );
    }
    return null;
  };

  const renderPreviewTag = () => {
    if (pdpInitData?.propertyDetails?.commonAttributes?.status === "PACT") {
      return (

        <div className="tags" style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', height: 18, textAlign: "center", borderRadius: 5, width: 80 }}>

          <p style={{ color: "white", fontSize: 12, paddingTop: 2 }}>
            PREVIEW
          </p>
        </div>
      );
    }
    return null;
  };

  const getBGColor = () => {
    return bgColor[pdpInitData?.propertyDetails?.commonAttributes?.propCategory]
  }

  const getBulletColor = () => {
    return color[pdpInitData?.propertyDetails?.commonAttributes?.propCategory] ? color[pdpInitData?.propertyDetails?.commonAttributes?.propCategory] : 'black';

  }

  const getDestination = () => {
    const add = `${streetNumber}, ${streetName},${city}, ${state} ${zip}`;
    return add;
  }

  const hanldeDocScroll = () => {
    const docElement = document.getElementById("Documents");
    window.scrollTo({
      top: docElement?.offsetTop - 70,
      behavior: "smooth",
    });
  }
  const renderGoogleMaps = () => {
    const googleMapsUrl = `https://www.google.com/maps/dir//${encodeURIComponent(getDestination())}`;
    window.open(googleMapsUrl, '_blank');
  }

  return (

    <section className="listing-title-area mt0 md-mt0 pt0 pb10">

      <div className="pl15">

        <div className="row mb0">
          <div className=" col-lg-8 col-xl-8">
            <div className="row pb20">
              {renderNewTag()}
              {renderPreviewTag()}
              {
                pdpInitData?.propertyDetails?.commonAttributes?.propCategory !== 'ABS' &&

                 <div className="tags" style={{ backgroundColor: `${getBGColor()}`, height: 18, textAlign: "center", borderRadius: 5, width: "auto", paddingTop: 2 }}>
                <p style={{ color: "white", fontSize: 12 }} tabIndex="0">
                  <FaCircle color={getBulletColor()} size="10px" />
                  {"  "}
                  {pdpInitData?.propertyDetails?.commonAttributes?.propCategory === 'COMMERCIAL' ? pdpInitData?.propertyDetails?.commonAttributes?.subType : isCWCOTFirstLook ? label['CWCOT'] : label[pdpInitData?.propertyDetails?.commonAttributes?.propCategory]}
                </p>



              </div>

              }

            </div>

            <div className="row pb5 pl0">

              <h2 className="propertyDetailsH1 pl0" tabIndex="0">{`${streetNumber && streetNumber !== null ? streetNumber : ''} ${streetName && streetName !== null ? streetName : ''
                }`}</h2>
              <p className="propertyDetailsTextMd pl0" tabIndex="0"> {`${city && city != null ? city : ''}, ${stateName && stateName != null ? stateName : ''
                } ${zip && zip != null ? zip : ''}`}
                <a href={""} className="direction-text" target="_blank"
                  onClick={(e) => {

                    e.preventDefault();
                    renderGoogleMaps()
                    trackButtonClick({
                      eventName: "gallery_section_directions",
                      eventCategory: "NEW-PDP",
                      eventSource: "on get direction click",
                      eventLabel: `propId: ${pdpInitData?.propertyDetails?.propertyId} | listingId: ${pdpInitData?.propertyDetails?.listingId}`,
                    });

                  }}> <TbLocation color='#118BF4' size="20px" /> Get Directions</a>
              </p>

            </div>

          </div>


          <div className="col-lg-4 col-xl-4 px-0 px-lg-3 pl30">
            <div className="mt15 mb20 d-flex pr5" style={{ alignContent: "flex-end", justifyContent: "flex-end" }} >


              {pdpInitData?.propertyDetails?.commonAttributes?.propCategory === 'COMMERCIAL' ?

                (
                  <div>
                    <button onClick={(e) => {
                      hanldeDocScroll()

                    }} className="impDocBtn">

                    <img
                      className="w-10"
                      src="/assets/images/document.png"
                      alt="bh1.jpg"
                    />

                      {/* <VscCopy color="white" size={25} style={{ paddingRight: 5 }} /> */}
                      {"  "}IMPORTANT DOCUMENTS
                      {/* <span style={{padding:20}}></span> */}
                    </button>
                  </div>
                )
                :

                (<div className="mt15 mb20 d-flex" style={{ alignContent: "flex-end", justifyContent: "flex-end" }} >
                  {pdpInitData?.propertyDetails?.commonAttributes?.bedroomsNum ?
                    <div className="cols mr10">
                      <h2 className="propertyDetailsH1 text-center mb0" tabIndex="0">{pdpInitData?.propertyDetails?.commonAttributes?.bedroomsNum} </h2>
                      <p className="propertyDetailsTextMd  text-center mb0 fz24" tabIndex="0">Beds</p>
                    </div>
                    : ""
                  }
                  {pdpInitData?.propertyDetails?.commonAttributes?.bathsNum ? <div className="cols ml10 mr10">
                    <h2 className="propertyDetailsH1 text-center mb0 " tabIndex="0">{pdpInitData?.propertyDetails?.commonAttributes?.bathsNum}</h2>
                    <p className="propertyDetailsTextMd text-center mb0 fz24" tabIndex="0">Baths</p>
                  </div>
                    : ""
                  }
                  {(pdpInitData?.propertyDetails?.detailedAttributes?.squareFeet &&
                    pdpInitData?.propertyDetails?.detailedAttributes?.squareFeet !== "0 Sq. Ft.") ? <div className="cols ml10">
                    <h2 className="propertyDetailsH1 text-center mb0" tabIndex="0">{pdpInitData?.propertyDetails?.detailedAttributes?.squareFeet.replace('Sq. Ft.', '')}</h2>
                    <p className="propertyDetailsTextMd text-center mb0 fz24" tabIndex="0">Square Feet</p>
                  </div>
                    :
                    pdpInitData?.propertyDetails?.commonAttributes?.lotSize ?
                      <div className="cols ml10">
                        <h2 className="propertyDetailsH1 text-center mb0" tabIndex="0">{pdpInitData?.propertyDetails?.commonAttributes?.lotSize.replace('Sq. Ft.', '').replace('Acre', '').trim()}</h2>
                        <p className="propertyDetailsTextMd text-center mb0 fz24" tabIndex="0">
                          {(() => {
                            const unit = pdpInitData?.propertyDetails?.commonAttributes?.lotSizeUnit;
                            if (!unit || unit === 'Sq. Ft.') return 'Square Feet';
                            return unit.charAt(0).toUpperCase() + unit.slice(1);
                          })()}
                        </p>
                      </div>
                      : ""
                  }

                </div>
                )}




            </div>

          </div>
          {/* End .row */}
        </div>
      </div>


      {/* End .row */}

    </section>
  )
}
